import * as Sentry from "@sentry/browser";

let initialized = false;

export function initSentry() {
  if (initialized) return;
  if (typeof window === "undefined") return;

  const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV ?? "development",
    release: process.env.NEXT_PUBLIC_APP_VERSION ?? "0.1.0",
    tracesSampleRate: 0.1,
  });

  initialized = true;
}

export function captureError(err: unknown, extra?: Record<string, unknown>) {
  if (!initialized) return;
  Sentry.captureException(err, { extra });
}
